import { useContext } from "react";
import StyleConfigsContext from "../context/StyleConfigContext";

export default function useStyleConfigs() {
  return useContext(StyleConfigsContext);
}
